export default __webpack_public_path__ + "cb747ddc8381a973072efdbd0bff3eef.png";